import { SettingConst } from '@faire/web-api--source/types';

/**
 * Enables new Search Suggestions Empty State
 */
export const ENABLE_NEW_SEARCH_SUGGESTIONS_EMPTY_STATE_250530 =
  'ENABLE_NEW_SEARCH_SUGGESTIONS_EMPTY_STATE_250530' as SettingConst<
    'ENABLE_NEW_SEARCH_SUGGESTIONS_EMPTY_STATE_250530',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS'
  >;
